const ITEMS = ["Masala Dosa", "Filter Coffee", "Veg Biryani", "Idli & Vada", "Chaat", "Uttapam", "Premium Catering", "Edison · NJ"];

const Marquee = () => (
  <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/8 py-7 md:py-9">
    <div className="flex w-max animate-marquee whitespace-nowrap">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="px-6 font-serif text-4xl italic md:px-10 md:text-6xl text-outline">{item}</span>
          <span className="text-gold text-xl md:text-2xl">✦</span>
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
